export default "__VITE_ASSET__e09423ff__"